<template>
<form method="post" action="https://css-tricks.com/examples/DragAndDropFileUploading//?" enctype="multipart/form-data" novalidate class="box">
  
  <div class="box__input">
    <svg class="box__icon" xmlns="http://www.w3.org/2000/svg" width="50" height="43" viewBox="0 0 50 43"><path d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"/></svg>
    <input type="file" name="files[]" id="file" class="box__file" data-multiple-caption="{count} files selected" multiple />
    <label for="file"><strong>Choose a file</strong><span class="box__dragndrop"> or drag it here</span>.</label>
    <button type="submit" class="box__button">Upload</button>
  </div>

  <div class="box__uploading">Uploading&hellip;</div>
  <div class="box__success">Done! <a href="https://css-tricks.com/examples/DragAndDropFileUploading//?" class="box__restart" role="button">Upload more?</a></div>
  <div class="box__error">Error! <span></span>. <a href="https://css-tricks.com/examples/DragAndDropFileUploading//?" class="box__restart" role="button">Try again!</a></div>
</form>   
</template>

<script>
export default {
  methods: {
    // feature detection for drag&drop upload
    isAdvancedUpload () {
      let div = document.createElement('div')
      return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window
    }
  },
  mounted () {
    // applying the effect for every form
    let forms = document.querySelectorAll('.box')
    Array.prototype.forEach.call(forms, (form) => {
      let input = form.querySelector('input[type="file"]')
      let label = form.querySelector('label')
      let errorMsg = form.querySelector('.box__error span')
      let restart = form.querySelectorAll('.box__restart')
      let droppedFiles = false
      let showFiles = (files) => {
        label.textContent = files.length > 1 ? (input.getAttribute('data-multiple-caption') || '').replace('{count}', files.length) : files[ 0 ].name
      }
      let triggerFormSubmit = () => {
        var event = document.createEvent('HTMLEvents')
        event.initEvent('submit', true, false)
        form.dispatchEvent(event)
      }

      // letting the server side to know we are going to make an Ajax request
      var ajaxFlag = document.createElement('input')
      ajaxFlag.setAttribute('type', 'hidden')
      ajaxFlag.setAttribute('name', 'ajax')
      ajaxFlag.setAttribute('value', 1)
      form.appendChild(ajaxFlag)

      // automatically submit the form on file select
      input.addEventListener('change', (e) => {
        showFiles(e.target.files)
        triggerFormSubmit()
      })

      // drag&drop files if the feature is available
      if (this.isAdvancedUpload()) {
        // letting the CSS part to know drag&drop is supported by the browser
        form.classList.add('has-advanced-upload')['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((event) => {
          form.addEventListener(event, (e) => {
            // preventing the unwanted behaviours
            e.preventDefault()
            e.stopPropagation()
          })
        })['dragover', 'dragenter'].forEach((event) => {
          form.addEventListener(event, () => {
            form.classList.add('is-dragover')
          })
        })['dragleave', 'dragend', 'drop'].forEach((event) => {
          form.addEventListener(event, () => {
            form.classList.remove('is-dragover')
          })
        })
        form.addEventListener('drop', (e) => {
          droppedFiles = e.dataTransfer.files // the files that were dropped
          showFiles(droppedFiles)
          triggerFormSubmit()
        })
      }


      // if the form was submitted
      form.addEventListener('submit', (e) => {
        // preventing the duplicate submissions if the current one is in progress
        if (form.classList.contains('is-uploading')) return false

        form.classList.add('is-uploading')
        form.classList.remove('is-error')
        // ajax file upload for modern browsers
        if (isAdvancedUpload) {
          e.preventDefault()

          // gathering the form data
          var ajaxData = new FormData(form)
          if (droppedFiles) {
            Array.prototype.forEach.call(droppedFiles, (file) => {
            ajaxData.append(input.getAttribute('name'), file)
            })
          }

          // ajax request
          var ajax = new XMLHttpRequest()
          ajax.open(form.getAttribute('method'), form.getAttribute('action'), true)

          ajax.onload = () => {
            form.classList.remove('is-uploading')
            if (ajax.status >= 200 && ajax.status < 400) {
              var data = JSON.parse(ajax.responseText)
              form.classList.add(data.success == true ? 'is-success' : 'is-error')
              if (!data.success) errorMsg.textContent = data.error
            }
            else alert('Error. Please, contact the webmaster!')
          }

          ajax.onerror = () => {
            form.classList.remove('is-uploading')
            alert('Error. Please, try again!')
          }

          ajax.send(ajaxData)
        } 
      })

      // restart the form if has a state of error/success
      Array.prototype.forEach.call(restart, (entry) => {
        entry.addEventListener('click', (e) => {
          e.preventDefault()
          form.classList.remove('is-error', 'is-success')
          input.click()
        })
      })

      // Firefox focus bug fix for file input
      input.addEventListener('focus', () => { input.classList.add('has-focus') })
      input.addEventListener('blur', () => { input.classList.remove('has-focus') })

    })
  }
}
</script>

<style>
.box {
    font-size: 1.25rem;
    /* 20 */
    background-color: #f0f0f0;
    position: relative;
    padding: 40px 20px;
}

.box.has-advanced-upload {
    outline: 2px dashed #dedede;
    /* border: 1px solid #dedede; */
    border-radius: 10px;
    outline-offset: -10px;
    -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
    transition: outline-offset .15s ease-in-out, background-color .15s linear;
    }

.box.is-dragover {
    outline-offset: -20px;
    /* outline-color: #c8dadf; */
    background-color: #dedede;
}

.box__dragndrop,
.box__icon {
    display: none;
}

.box.has-advanced-upload .box__dragndrop {
    display: inline;
}

.box.has-advanced-upload .box__icon {
    width: 100%;
    height: 80px;
    fill: #008cba;
    display: block;
    margin-bottom: 40px;
}

.box.is-uploading .box__input,
.box.is-success .box__input,
.box.is-error .box__input {
    visibility: hidden;
}

.box__uploading,
.box__success,
.box__error {
    display: none;
}

.box.is-uploading .box__uploading,
.box.is-success .box__success,
.box.is-error .box__error {
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
}

.box__uploading {
    font-style: italic;
}

.box__success {
    -webkit-animation: appear-from-inside .25s ease-in-out;
    animation: appear-from-inside .25s ease-in-out;
}

@-webkit-keyframes appear-from-inside {
    from {
        -webkit-transform: translateY(-50%) scale(0);
    }
    75% {
        -webkit-transform: translateY(-50%) scale(1.1);
    }
    to {
        -webkit-transform: translateY(-50%) scale(1);
    }
}

@keyframes appear-from-inside {
    from {
        transform: translateY(-50%) scale(0);
    }
    75% {
        transform: translateY(-50%) scale(1.1);
    }
    to {
        transform: translateY(-50%) scale(1);
    }
}

.box__restart {
    font-weight: 700;
}

.box__restart:focus,
.box__restart:hover {
    color: #39bfd3;
}

.js .box__file {
    width: 0.1px;
    height: 0.1px;
    opacity: 0;
    overflow: hidden;
    position: absolute;
    z-index: -1;
}

.js .box__file+label {
    max-width: 80%;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: pointer;
    display: inline-block;
    overflow: hidden;
}

.js .box__file+label:hover strong,
.box__file:focus+label strong,
.box__file.has-focus+label strong {
    color: #39bfd3;
}

.js .box__file:focus+label,
.js .box__file.has-focus+label {
    outline: 1px dotted #000;
    outline: -webkit-focus-ring-color auto 5px;
}

.js .box__file+label * {
    /* pointer-events: none; */
    /* in case of FastClick lib use */
}

.no-js .box__file+label {
    display: none;
}

.no-js .box__button {
    display: block;
}

.box__button {
    font-weight: 700;
    color: #e5edf1;
    background-color: #39bfd3;
    display: none;
    padding: 8px 16px;
    margin: 40px auto 0;
}

.box__button:hover,
.box__button:focus {
    background-color: #0f3c4b;
}
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue